import { CloseOutline18Icon } from "@vygruppen/spor-icon-react";
import { ButtonTextContainer } from "features/CenterContent/shared/Tabs/TabsCenter";
import {
  ActiveTab,
  InActiveTab,
} from "features/CenterContent/shared/Tabs/TabsStyle";
import {
  DecisionSupportTab,
  InfrastructureEventTab,
  useTabsContext,
} from "features/CenterContent/shared/Tabs/useTabsContext";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CrossButton } from "shared/components/buttons/CrossButton";
import { Text } from "shared/components/Spor";
import * as ROUTES from "shared/utils/routes";

export const DecisionSupportTabElement = ({
  tab: _tab,
  index,
}: {
  tab: InfrastructureEventTab | DecisionSupportTab;
  index: number;
}) => {
  const tab: DecisionSupportTab =
    _tab.type === "infrastructureEvent"
      ? {
          type: "decision-support",
          stretchName: _tab.stretchName,
          uuid: _tab.incidentId,
        }
      : _tab;

  const { activeIdTabs, setActiveIdTabs } = useTabsContext();
  const { uuid } = useParams();
  const navigate = useNavigate();
  const selected = tab.uuid === uuid;
  const TabElement = selected ? ActiveTab : InActiveTab;

  return (
    <TabElement
      title={`Visuell beslutningsstøtte: ${tab.stretchName || tab.uuid}`}
      key={index}
      onClick={(event) => {
        event.preventDefault();
        void navigate(
          generatePath(ROUTES.ALTERNATIVE_TRANSPORT_DECISION_SUPPORT, {
            uuid: tab.uuid,
          }),
        );
      }}
      style={{
        padding: "4px 10px",
        borderRadius: "6px 6px 0px 0px",
      }}
    >
      <ButtonTextContainer>
        <Text variant="xs" margin="auto">
          {tab.stretchName || tab.uuid}
        </Text>
        <CrossButton
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            if (selected) {
              if (activeIdTabs.length === 1) {
                sessionStorage.removeItem("openTabs");
                void navigate(ROUTES.DASHBOARD);
              } else {
                const prevTab =
                  activeIdTabs[index - 1] || activeIdTabs[index + 1];
                if (prevTab) {
                  // Navigate to the previous tab based on its type
                  if ("busId" in prevTab) {
                    void navigate(
                      generatePath(ROUTES.BUS, {
                        vehicleUuid: prevTab.busId,
                      }),
                    );
                  } else if ("trainNumber" in prevTab) {
                    void navigate(
                      generatePath(ROUTES.TRAIN, {
                        countryCode: prevTab.countryCode,
                        trainNumber: prevTab.trainNumber,
                        trainDate: prevTab.trainDate,
                      }),
                    );
                  } else if (prevTab.type === "infrastructureEvent") {
                    void navigate(
                      generatePath(
                        ROUTES.ALTERNATIVE_TRANSPORT_DECISION_SUPPORT,
                        {
                          uuid: prevTab.incidentId,
                        },
                      ),
                    );
                  } else if (prevTab.type === "decision-support") {
                    void navigate(
                      generatePath(
                        ROUTES.ALTERNATIVE_TRANSPORT_DECISION_SUPPORT,
                        {
                          uuid: prevTab.uuid,
                        },
                      ),
                    );
                  }
                }
              }
            }
            setActiveIdTabs((prevArr: any) => {
              prevArr.splice(index, 1);
              return Array.from(prevArr);
            });
          }}
        >
          <CloseOutline18Icon marginLeft="4px" />
        </CrossButton>
      </ButtonTextContainer>
    </TabElement>
  );
};
